// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum AutomationType {
    DriStack = 'DriStack',
    AutoBin = 'AutoBin',
    Special = 'Special',
    PremierPlus = 'PremierPlus',
}
export default AutomationType;
